// LogoutButton.jsx
import React from "react";
import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../AuthContext"; // Add this import

export default function LogoutButton() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { logout } = useAuth(); // Get logout function from context

    const handleLogout = () => {
        logout(); // Call the context logout
        navigate("/login");
    };

    return (
        <Button colorScheme="orange" onClick={handleLogout}>
            {t("text_logout")}
        </Button>
    );
}